import GlobalTable from "@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue";
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import {
    ADMIN_VERIFY_APPLICATION_URL,
    APPROVED,
    get_headers,
    get_user_role,
    NOT_APPROVED,
    VIEW_FORM_STATUS,
    VIEW_REQUESTS_INFO_URL,
    GET_TABS_DETAILS,
    GET_TRANSITION_HISTORY_URL,
    SHARE_ENTITY_ACCESS_URL,
} from '@/utils/constants/constants';
import alert_mixin from "@/utils/mixins/alert_mixin";
import format_question_type from '@/utils/mixins/formatting_mixins';
import InvoiceOverview from "@/views/probaworkflows_base/invoicing/invoice_overview/InvoiceOverview.vue";
import axios from 'axios';
import ApplicationContracts from "../application_contracts/ApplicationContracts.vue";
import VerificationOverview from "../verification_managment/verification_overview/VerificationOverview.vue";

export default {
    name: "ApplicationOverview",
    mixins: [alert_mixin, format_question_type],
    components: {
        NavigationBackButton,
        GlobalTable,
        InvoiceOverview,
        VerificationOverview,
        ApplicationContracts,
    },
    data: () => ({
        allowed_actions: [],
        is_loading_allowed_actions: false,
        show_form: true,
        show_verification_component: false,
        active_tab: "",
        tabs: [],
        active_document_tabs: "Preview document",
        document_tabs: ['Preview document', 'Signed documents'],
        active_view: "application",
        requests: [],
        dropdown_expanded: false,
        steps: [],
        founder_name: "",
        form_name: "",
        form_id: "",
        all_application_ids: [],
        current_application_index: -1,
        profile_role_id: null,
        profile_role_form_id: '',
        headers: '',
        status: null,
        unresolved_requests: [],
        resolved_requests: [],
        user_role: get_user_role(),
        application_id: null,
        status_approved: APPROVED,
        status_not_approved: NOT_APPROVED,
        current_status: null,
        status_list: [],
        project_id: null,
        entity_profile_id: null,
        override_error: false,
        selected_status: "",
        current_status_id: null,
        trust_number_input: "",
        temp_approval_status: null,
        approval_notes: '',
        approval_action_type: 'move',
        transition_history: [],
        loading_history: false,
        show_condition_details: false,
        form_data: null,
        current_condition_details: null,
        is_auto_transitioning: false,
        auto_transition_done: false,
        share_email: "",
        is_sharing_credentials: false,
    }),

    created() {
        this.initialize_data_from_route();
    },

    mounted() {
        this.headers = get_headers();
        this.project_id = sessionStorage.getItem('project_id');
        this.application_id = sessionStorage.getItem('application_id');
        this.entity_profile_id = sessionStorage.getItem("entity_profile_id");
        if (this.application_id) {
            const parsed_id = parseInt(this.application_id, 10);
            if (!isNaN(parsed_id)) {
                this.application_id = parsed_id;
            } else {
                this.application_id = null;
            }
        }

        this.view_form_status().then(() => {
            if (this.application_id && !isNaN(this.application_id) && this.current_status_id) {
                this.fetch_allowed_actions();
            }
        });

        this.profile_role_form_id = this.$route.query.profile_role_form_id;
    },

    computed: {
        is_non_entity() {
            return get_user_role() !== "Entity";
        },
        parsed_allowed_actions() {
            if (!Array.isArray(this.allowed_actions)) return [];
            return this.allowed_actions.flatMap(item => {
                const raw_actions = Reflect.get(item, 'action') || "";
                return raw_actions.split(",").map(a => a.trim());
            });
        },

        is_approve_allowed() {
            return this.parsed_allowed_actions.includes("Approve");
        },

        target_status() {
            if (!Array.isArray(this.allowed_actions) || this.allowed_actions.length === 0) {
                return null;
            }
            return Reflect.get(this.allowed_actions[0], 'to_status_name') || null;
        },

        current_status_info() {
            return this.get_status_id(this.status);
        },
        should_fetch_allowed_actions() {
            return this.application_id &&
                !isNaN(this.application_id) &&
                this.current_status_id &&
                !this.is_loading_allowed_actions;
        },

        filtered_status_list() {
            if (!this.status || !this.status_list || this.status_list.length === 0) {
                return this.status_list || [];
            }

            return this.status_list.filter(status_item => {
                const is_current_status =
                    status_item.raw_status === this.status ||
                    status_item.human_readable_status === this.status ||
                    status_item.raw_status === this.$route.query.status;

                return !is_current_status;
            });
        },

        is_moving_to_master_registered() {
            const status_to_check = this.temp_approval_status || this.target_status || this.selected_status;

            if (!status_to_check || !this.status) return false;

            const current_is_submitted_to_master =
                this.status.toLowerCase().includes('submitted to master') ||
                this.status === 'Submitted to Master';

            const target_is_master_registered =
                status_to_check.toLowerCase().includes('master registered') ||
                status_to_check === 'Master Registered';

            return current_is_submitted_to_master && target_is_master_registered;
        },

        modal_status_label() {
            return this.temp_approval_status || this.selected_status || this.target_status || '—';
        },
        modal_action_verb() {
            return this.approval_action_type === 'override' ? 'Override' : 'Move';
        },
        modal_action_title() {
            return `${this.modal_action_verb} Application to ${this.format_question_type(this.modal_status_label)}`;
        },
        modal_action_button_label() {
            return `${this.modal_action_verb} Application to ${this.format_question_type(this.modal_status_label)}`;
        },
        modal_action_notes_placeholder() {
            return `Enter reason for ${this.modal_action_verb.toLowerCase()}...`;
        },
        modal_action_notes_help() {
            return `Please provide a reason for this ${this.modal_action_verb.toLowerCase()}.`;
        },

    },

    methods: {

        async fetch_allowed_actions() {
            this.is_loading_allowed_actions = true;

            try {
                const request_params = {
                    application_id: this.application_id != null ? Number(this.application_id) : null,
                    entity_profile_id: this.$route.query.entity_profile_id
                        ? Number(this.$route.query.entity_profile_id)
                        : null,
                    current_status_id: this.current_status_id ? Number(this.current_status_id) : null
                };

                const response = await axios.get(GET_TABS_DETAILS, {
                    headers: get_headers(),
                    params: request_params
                });

                if (Reflect.get(response, 'data')?.status === "success") {
                    this.allowed_actions = Reflect.get(response.data, 'allowed_actions') || [];
                    this.form_data = Reflect.get(response.data, 'data') || [];
                    await this.check_automatic_transition();
                }
            } catch (error) {
                this.allowed_actions = [];
                this.form_data = [];
            } finally {
                this.is_loading_allowed_actions = false;
            }
        },

        get_auto_transition_action() {
            if (!Array.isArray(this.allowed_actions) || this.allowed_actions.length === 0) {
                return null;
            }

            return this.allowed_actions.find((action) => {
                const type_name = String(
                    Reflect.get(action, 'transition_type') || Reflect.get(action, 'transition_type_name') || ''
                ).toLowerCase();
                return type_name === 'automatic';
            });
        },

        build_auto_note(target_status) {
            const formatted_status = this.format_question_type(target_status);
            return `System automatically moved it to ${formatted_status} as it met all conditions on transition rules.`;
        },

        async check_automatic_transition() {
            if (this.is_auto_transitioning || this.auto_transition_done) {
                return;
            }

            const auto_action = this.get_auto_transition_action();
            if (!auto_action) {
                return;
            }

            const target_status =
                Reflect.get(auto_action, 'to_status_name') ||
                Reflect.get(auto_action, 'to_status') ||
                Reflect.get(auto_action, 'to_status_status') ||
                Reflect.get(auto_action, 'to_status_label');

            if (!target_status) {
                return;
            }

            if (this.is_moving_to_master_registered) {
                return;
            }

            this.is_auto_transitioning = true;

            try {
                await this.submit_verification(target_status, null, {
                    note: this.build_auto_note(target_status),
                    actionTaken: "Auto Status Update",
                });
                this.auto_transition_done = true;
            } catch (error) {
                this.show_error(
                    error?.response?.data?.message || "Automatic transition failed. Please try again."
                );
            } finally {
                this.is_auto_transitioning = false;
            }
        },


        view_condition_details() {
            if (this.allowed_actions && this.allowed_actions.length > 0 && this.allowed_actions[0]?.condition_details) {
                this.current_condition_details = this.allowed_actions[0].condition_details;
            } else {
                this.current_condition_details = {
                    all_met: false,
                    conditions: [],
                    message: "No allowed actions available. This means conditions for transitioning from the current status are not met. Check the form data for completeness and verification requirements."
                };
            }
            this.show_condition_details = true;
        },


        parse_route_query_parameters(query) {
            const parsed_data_queries = {
                all_application_ids: JSON.parse(Reflect.get(query, 'all_application_ids') || '[]'),
                current_application_index: parseInt(Reflect.get(query, 'current_application_index'), 10) || -1,
                profile_role_form_id: Reflect.get(query, 'profile_role_form_id') || null,
                profile_role_id: Reflect.get(query, 'profile_role_id') || null,
                founder_name: Reflect.get(query, 'founder_name') || "",
                form_name: Reflect.get(query, 'form_name') || "",
                form_id: Reflect.get(query, 'form_id') || "",
                status: Reflect.get(query, 'status') || null
            };
            return parsed_data_queries;
        },

        initialize_data_from_route() {
            const parsed_data = this.parse_route_query_parameters(this.$route.query);
            Object.assign(this, parsed_data);

            if (!Array.isArray(this.all_application_ids)) {
                this.all_application_ids = [];
            }
            if (typeof this.current_application_index !== 'number' || isNaN(this.current_application_index)) {
                this.current_application_index = -1;
            }
        },

        initialize_component() {
            if (this.form_name) {
                this.tabs = [this.form_name];
                this.active_tab = this.form_name;
            }
        },

        setactive_view(view) {
            this.active_view = view;
        },

        set_active_tab(tab) {
            this.active_tab = tab;
        },

        set_active_document_tab(document_tab) {
            this.active_document_tabs = document_tab;
        },

        redirect_to_manual_verification() {
            this.show_verification_component = !this.show_verification_component;
        },

        redirect_to_view_requests_information() {
            this.$router.push({
                path: "/view_requests",
                query: {
                    profile_role_form_id: this.profile_role_form_id,
                    status: this.status
                },
            });
        },

        redirect_to_pending_applications() {
            this.$router.push({
                path: "/pending_applications",
                query: {
                    status: this.status
                }
            });
        },

        redirect_to_invoice() {
            this.$router.push({
                path: "/invoice_overview",
                query: {
                    status: this.status
                }
            });
        },

        get_application_requests() {
            axios.get(VIEW_REQUESTS_INFO_URL, {
                headers: this.headers,
                params: {
                    application_form_id: parseInt(this.profile_role_form_id, 10),
                }
            })
                .then(response => {
                    const response_data = response.data;

                    if (Reflect.get(response_data, 'status') === 'success') {
                        const mapped_request_data = Reflect.get(response_data, 'data').map(request => ({
                            id: Reflect.get(request, 'id'),
                            sender: Reflect.get(request, 'requested_by_first_name') + " " + Reflect.get(request, 'requested_by_last_name'),
                            message: Reflect.get(request, 'message'),
                            is_resolved: Reflect.get(request, 'is_resolved'),
                            is_sent: Reflect.get(request, 'is_sent'),
                            is_read: Reflect.get(request, 'is_read'),
                            date: Reflect.get(request, 'date_created'),
                        }));

                        this.unresolved_requests = mapped_request_data.filter(request => Reflect.get(request, 'is_resolved') === false);
                        this.resolved_requests = mapped_request_data.filter(request => Reflect.get(request, 'is_resolved') === true);

                        this.requests = mapped_request_data.map(req => Reflect.get(req, 'message'));
                    } else {
                        this.show_error('Error fetching requests');
                    }
                })
                .catch(error => {
                    if (error.response && error.response.data) {
                        this.show_error(Reflect.get(Reflect.get(error, 'response'), 'data')?.message);
                    }
                });
        },

        async view_form_status() {
            const payload = { project_id: this.project_id };

            try {
                const response = await axios.get(VIEW_FORM_STATUS, {
                    headers: this.headers,
                    params: payload,
                });

                this.status_list = Reflect.get(Reflect.get(response, 'data'), 'data').map((item) => ({
                    id: Reflect.get(item, 'id'),
                    raw_status: Reflect.get(item, 'status'),
                    human_readable_status: this.format_question_type(Reflect.get(item, 'status')),
                }));

                if (this.status && this.status_list.length > 0) {
                    const raw_status_from_route = this.$route.query.status;

                    let found_status = null;

                    found_status = this.status_list.find(item =>
                        item.raw_status === this.status
                    );

                    if (!found_status && raw_status_from_route) {
                        found_status = this.status_list.find(item =>
                            item.raw_status === raw_status_from_route
                        );
                    }

                    if (!found_status) {
                        found_status = this.status_list.find(item =>
                            item.human_readable_status === this.status
                        );
                    }

                    if (!found_status) {
                        found_status = this.status_list.find(item =>
                            item.raw_status.toLowerCase() === this.status.toLowerCase() ||
                            item.human_readable_status.toLowerCase() === this.status.toLowerCase()
                        );
                    }

                    if (found_status) {
                        this.current_status_id = found_status.id;

                        if (this.application_id && !isNaN(this.application_id)) {
                            this.fetch_allowed_actions();
                        }
                    }
                }

            } catch (error) {
                this.show_error(`Error fetching status: ${Reflect.get(Reflect.get(error, 'response'), 'data')?.message}`);
            }
        },
        admin_verify(status) {
            if (!status) {
                this.show_error("No valid status returned from workflow.");
                return;
            }
            this.temp_approval_status = status;
            const current_is_submitted_to_master =
                this.status &&
                (this.status.toLowerCase().includes('submitted to master') ||
                    this.status === 'Submitted to Master');

            const is_master_registered =
                status &&
                (status.toLowerCase().includes('master registered') ||
                    status === 'Master Registered');

            if (current_is_submitted_to_master && is_master_registered) {
                return;
            }

            this.submit_verification(status);
        },

        handle_trust_number_modal_open(status, actionType = 'move') {
            this.temp_approval_status = status;
            this.approval_action_type = actionType;
            this.trust_number_input = "";
            this.approval_notes = "";
            this.$router.replace({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    trust_number: undefined
                }
            });
        },

        submit_verification(status, trust_number = null, options = {}) {
            const data = {
                application_id: parseInt(this.application_id, 10),
                status: status,
                note: options.note || this.approval_notes || "",
                entity_profile_id: this.entity_profile_id ? parseInt(this.entity_profile_id, 10) : null,
            };

            if (trust_number !== null && trust_number !== undefined && trust_number !== "") {
                data.trust_number = trust_number;
            }
            if (options.actionTaken) {
                data.action_taken = options.actionTaken;
            } else if (this.is_moving_to_master_registered && trust_number) {
                data.action_taken = "Approve";
            } else if (status.toLowerCase().includes('reject') || status.toLowerCase().includes('decline')) {
                data.action_taken = "Reject";
            } else {
                data.action_taken = "Status Update";
            }

            axios.post(ADMIN_VERIFY_APPLICATION_URL, data, {
                headers: this.headers
            })
                .then(response => {
                    if (response.data.status === "success") {
                        const new_status = response.data.data;
                        this.show_success(`Entity application moved to ${this.format_question_type(status)} successfully.`);
                        this.status = new_status || status;

                        if (trust_number) {
                            const currentPath = this.$route.path;
                            this.$router.replace({
                                path: currentPath,
                                query: {
                                    ...this.$route.query,
                                    trust_number: trust_number,
                                    status: new_status || this.temp_approval_status || this.$route.query.status
                                }
                            });
                            this.$emit('status-updated', {
                                status: new_status,
                                formatted_status: this.format_question_type(new_status),
                                trust_number: trust_number
                            });
                        } else {
                            this.$emit('status-updated', {
                                status: new_status,
                                formatted_status: this.format_question_type(new_status)
                            });
                        }

                        this.trust_number_input = "";
                        this.temp_approval_status = null;
                        this.approval_notes = "";
                        this.approval_action_type = 'move';

                        this.view_form_status();
                        this.fetch_allowed_actions();
                    } else {
                        this.show_error('Error during the application verification');
                    }
                })
                .catch(error => {
                    this.show_error(error.response?.data?.message);
                });
        },


        async share_credentials() {
            const email = (this.share_email || "").trim();
            if (!email) {
                this.show_error("Please enter an email address.");
                return;
            }

            const entity_profile_id = this.$route.query.entity_profile_id
                ? Number(this.$route.query.entity_profile_id)
                : null;

            const entity_type_id = this.$route.query.entity_type_id
                ? Number(this.$route.query.entity_type_id)
                : null;

            if (!entity_profile_id || Number.isNaN(entity_profile_id)) {
                this.show_error("Missing entity_profile_id. Please reload the page.");
                return;
            }

            if (!entity_type_id || Number.isNaN(entity_type_id)) {
                this.show_error("Missing entity_type_id. Please reload the page.");
                return;
            }

            const payload = {
                email: email,
                entity_profile_id: entity_profile_id,
                entity_type_id: entity_type_id,
            };

            this.is_sharing_credentials = true;

            try {
                const response = await axios.post(SHARE_ENTITY_ACCESS_URL, payload, {
                headers: this.headers,
                });

                if (response?.data?.status === "success") {
                this.show_success(response.data.message || "Credentials shared successfully.");

                // reset
                this.share_email = "";

                // close modal using data-bs-dismiss behavior
                if (this.$refs.share_credentials_dismiss_btn) {
                    this.$refs.share_credentials_dismiss_btn.click();
                }
                return;
                }

                this.show_error(response?.data?.message || "Failed to share credentials.");
            } catch (error) {
                this.show_error(error?.response?.data?.message || "Failed to share credentials.");
            } finally {
                this.is_sharing_credentials = false;
            }
        },


        handle_trust_number_submit() {
            const trimmed_trust_number = this.trust_number_input.trim();
            if (!trimmed_trust_number) {
                this.show_error("Please enter a Trust Number before proceeding.");
                return;
            }

            if (!this.approval_notes.trim()) {
                this.show_error("Please enter notes for this action.");
                return;
            }

            if (this.temp_approval_status) {
                this.submit_verification(this.temp_approval_status, trimmed_trust_number);
            }
            this.trust_number_input = "";
            this.temp_approval_status = null;
            this.approval_notes = "";
        },

        get_status_id(status_text) {
            if (!status_text || !Array.isArray(this.status_list) || this.status_list.length === 0) {
                return null;
            }

            const status_obj = this.status_list.find(item =>
                item.raw_status === status_text ||
                item.human_readable_status === status_text
            );

            return status_obj ? status_obj.id : null;
        },

        async view_transition_history() {
            this.loading_history = true;

            try {
                const response = await axios.get(GET_TRANSITION_HISTORY_URL, {
                    headers: this.headers,
                    params: {
                        application_id: this.application_id
                    }
                });

                if (response.data.status === "success") {
                    this.transition_history = response.data.data;
                } else {
                    this.show_error('Failed to load transition history');
                }
            } catch (error) {
                this.show_error(error.response?.data?.message || 'An error occurred while loading history');
            } finally {
                this.loading_history = false;
            }
        },

        format_date(dateString) {
            const date = new Date(dateString);
            return date.toLocaleString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        }
    },
};